app.factory('templateService', ['$q', 'baseService', 'objectHelper', 'config',
    function($q, baseService, objectHelper, config) {

	    function TemplateService() {
	
	    	this.getDataPage = function(criteria) {
	            return baseService.post(config.API_URL + '/templates/dataPage', criteria).then(
	                function(successResponse) {
	                    var dataPage = objectHelper.translateObject(successResponse, DataPageVO);
	                    dataPage.data = objectHelper.translateArray(dataPage.data, TemplateVO);

						return dataPage;
	                },
	                function(errorResponse) {
	                    return $q.reject(errorResponse);
	                }
	            );
	        };
	        
	        this.getById = function(id) {
				return baseService.get(config.API_URL + '/templates/' + id).then(
	                function(successResponse) {
	                    var data = objectHelper.translateObject(successResponse, TemplateVO);
	                    return data;
	                },
	                function(errorResponse) {
	                    return $q.reject(errorResponse);
	                }
	            );
	        };

            this.save = function(template) {
                return baseService.post(config.API_URL + '/templates', template).then(
                    function(successResponse) {
                        var data = objectHelper.translateObject(successResponse, TemplateVO);
                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.saveFromVisitCard = function(visitCardId, template) {
                return baseService.post(config.API_URL + '/templates/createFromVisitCard/' + visitCardId, template).then(
                    function(successResponse) {
                        var data = objectHelper.translateObject(successResponse, TemplateVO);
                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.update = function(template) {
                return baseService.post(config.API_URL + '/templates/' + template.id, template).then(
                    function(successResponse) {
                        var data = objectHelper.translateObject(successResponse, TemplateVO);
                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };
	
	        this.delete = function(template) {
				return baseService.delete(config.API_URL + '/templates/' + template.id).then(
	                function(successResponse) {
						return successResponse;
	                },
	                function(errorResponse) {
	                    return $q.reject(errorResponse);
	                }
	            );
	        };
	        
	    }
	
	    return new TemplateService();
	}
]);
